<div class="flex flex-row justify-start items-center gap-2">
    <h4 class="mb-0" i18n>Attribute</h4>

    <button *ngIf="!editMode" (click)="edit()">
        <iota-icon icon="pencil-square" class="text-primary"></iota-icon>
    </button>
    <button class="btn btn-sm btn-circle btn-ghost btn-accent" *ngIf="editMode" (click)="add()">
        <iota-icon icon="plus"></iota-icon>
    </button>
    <button class="btn btn-sm btn-circle btn-ghost btn-accent" *ngIf="editMode" [disabled]="invalid" (click)="save()">
        <iota-icon flaticon="floppy-disk" size="1x"> </iota-icon>
    </button>
    <button class="btn btn-sm btn-circle btn-ghost btn-accent" *ngIf="editMode" (click)="cancel()">
        <iota-icon icon="x-mark"></iota-icon>
    </button>

    <div class="flex-1"></div>
    <button class="btn btn-sm btn-circle btn-ghost btn-primary" (click)="importAttributes()">
        <iota-icon icon="arrow-up-tray"></iota-icon>
    </button>
    <button class="btn btn-sm btn-circle btn-ghost btn-primary" (click)="exportAttributes()" *ngIf="attributes && attributes.length > 0">
        <iota-icon icon="arrow-down-tray"></iota-icon>
    </button>
    <button class="btn btn-sm btn-circle btn-ghost btn-primary" (click)="showHelp = !showHelp">
        <iota-icon icon="question-mark-circle"></iota-icon>
    </button>
</div>

<div class="flex flex-col justify-start items-stretch gap-4">
    <app-attribute
        *ngFor="let attribute of attributes"
        [attribute]="attribute"
        [disabled]="!editMode"
        (delete)="delete(attribute)"
        #attributes
    >
    </app-attribute>
</div>
<app-attributes-help *ngIf="showHelp" [attributeKeys]="possibleAttributeKeys" (afterClose)="showHelp = false"></app-attributes-help>
